var _defs, _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _g2, _g3, _g4, _path8, _path9, _path10, _rect, _rect2, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _g5, _path20, _g6, _path21, _path22, _path23, _g7, _g8, _g9, _g10, _g11, _g12, _g13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesignerAlt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 729.694,
    height: 641.611,
    viewBox: "0 0 729.694 641.611",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4cb8b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0099d6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_151",
    "data-name": "Rectangle 151",
    width: 729.694,
    height: 176.253,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52832",
    "data-name": "Path 52832",
    d: "M236.568,76.914s34.113,8.227,55.037,24.68S326.9,201.686,326.9,201.686s11.682,2.742,9.6,13.711c0,0-19.525-2.66-29.644,18.263a60.612,60.612,0,0,0-5.293,19.772s-10.311-.658-10.969-9.6c0,0-9.269-9.269-11.545-26.792-.055-.329-.11-.631-.137-.96,0,0-3.071,43.656,2.084,61.591H125.343l34.635-34.854s-48.675-10.969-56.572,4.113c0,0-6.856-13.026,4.113-21.938,0,0-2.386-89.479,11.325-113.117s82.6-37.349,82.6-37.349Z",
    transform: "translate(-101.289 -74.528)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1.056,
    y1: 0.761,
    x2: -0.281,
    y2: 0.052,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3490",
    "data-name": "Rectangle 3490",
    width: 123.908,
    height: 134.027,
    fill: "#2dabc3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3491",
    "data-name": "Rectangle 3491",
    width: 27.806,
    height: 97.103
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3496",
    "data-name": "Rectangle 3496",
    width: 34.168,
    height: 55.448,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3500",
    "data-name": "Rectangle 3500",
    width: 128.384,
    height: 128.386,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3508",
    "data-name": "Rectangle 3508",
    width: 26.289,
    height: 22.144,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3542",
    "data-name": "Rectangle 3542",
    width: 52.582,
    height: 16.229,
    fill: "#f8f9fa"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_31155",
    "data-name": "Group 31155",
    transform: "translate(-3551.601 -209.139)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_52275",
    "data-name": "Path 52275",
    d: "M0,165.112V447.383A132.117,132.117,0,0,0,132.117,579.5h338.04A132.117,132.117,0,0,0,602.274,447.383V132.128c0-78.036-67.282-139.068-144.95-131.492L119.285,33.62A132.117,132.117,0,0,0,0,165.112",
    transform: "translate(3603.457 270.25)",
    fill: "#e9ecef"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26459",
    "data-name": "Group 26459",
    transform: "translate(-1711.316 12.656)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_740",
    "data-name": "Group 740",
    transform: "translate(5262.917 439.217)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_294",
    "data-name": "Group 294",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16468",
    "data-name": "Path 16468",
    d: "M4.108,112.153c62.136,32.125,132.748,49.023,202.537,37.67,32.038-5.211,63.408-16.435,91-33.62,21.911-13.647,55.127-36.017,48.317-66.322-2.763-12.3-12.776-22.258-25.769-22.53-12.972-.272-24.573,8.758-31.136,19.357-15.973,25.8-3.574,60.171,14.719,81.045,20.229,23.082,51.634,36.311,82.193,35.694,35.208-.711,67.725-18.366,97.289-35.852C552.577,86.6,621.4,28.925,706.632,32.164c10.509.4,10.493-15.933,0-16.33-61.813-2.35-118.174,26.6-169.168,58.485-26.032,16.281-51.509,33.506-78.432,48.314-26.244,14.434-55.57,27.685-86.276,23.831-27.135-3.408-53.419-19.4-66.68-43.638-6.45-11.79-9.853-25.965-6.447-39.225,2.362-9.2,13.842-25.591,25.168-18.4,11.513,7.314,3.741,23.766-2.919,31.276C312.795,86.721,300.955,94.91,289.4,102.1c-23.956,14.92-50.614,24.9-78.261,30.383C143.264,145.952,72.978,129.4,12.349,98.053c-9.321-4.819-17.589,9.266-8.241,14.1",
    transform: "translate(0 12.788)",
    fill: "url(#linear-gradient)"
  }))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_52883",
    "data-name": "Path 52883",
    d: "M0,53.992v92.3a43.2,43.2,0,0,0,43.2,43.2H153.744a43.2,43.2,0,0,0,43.2-43.2V43.207a43.2,43.2,0,0,0-47.4-43L39.007,10.994A43.2,43.2,0,0,0,0,53.992",
    transform: "translate(3753.262 209.139)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27116",
    "data-name": "Group 27116",
    transform: "translate(3647.176 512.886)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_52827",
    "data-name": "Path 52827",
    d: "M19.554,210.305S3.786,175,40.121,147.577s44.561-47.3,44.561-47.3,12.274,64.39-9.941,94.95v44.219H20.955Z",
    transform: "translate(380.864 97.699)",
    fill: "#4e8fb7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_52828",
    "data-name": "Path 52828",
    d: "M83.359,197.406s1.78-24.68-22.793-41.2-24.217-33.181-24.217-33.181-18.875,47.265,4.985,74.383Z",
    transform: "translate(349.582 140.358)",
    fill: "#70b2dd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_52829",
    "data-name": "Path 52829",
    d: "M5.9,208.513s-3.8-33.25,27.239-51.074,37.547-40.791,37.547-40.791,17.139,57.93-10.969,91.865Z",
    transform: "translate(421.59 129.251)",
    fill: "#abdaf7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_52830",
    "data-name": "Path 52830",
    d: "M123.248,127.288c9.562,15.949,22.133,31.149,37.322,45.7v16.577H123.5s-11.715-6.307-35.186-24.241c0,0-7.7-51.288,34.936-38.035",
    transform: "translate(111.959 143.977)",
    fill: "#6d392f"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_52831",
    "data-name": "Path 52831",
    d: "M166.06,154.094s1.728,32.907,9.954,34.964,41.934-28.464,41.934-28.464l3.834-14.561-24.974-18.217s-29.734,9.14-30.749,26.279",
    transform: "translate(-163.944 148.707)",
    fill: "#341a1b"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_27097",
    "data-name": "Group 27097",
    transform: "translate(0 130.396)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27096",
    "data-name": "Group 27096",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3489",
    "data-name": "Rectangle 3489",
    width: 271.816,
    height: 239.764,
    transform: "translate(230.903 241.94) rotate(-170.651)",
    fill: "url(#linear-gradient-4)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_27100",
    "data-name": "Group 27100",
    transform: "translate(57.839 203.738)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27099",
    "data-name": "Group 27099"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27098",
    "data-name": "Group 27098",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52833",
    "data-name": "Path 52833",
    d: "M121.725,196.223s-5.827-50.731,13.026-94.95c0,0-3.085,67.185,24.337,86.038s74.04,15.082,85.695,47.989l-102.834-.913Z",
    transform: "translate(-120.875 -101.273)",
    opacity: 0.267
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_27103",
    "data-name": "Group 27103",
    transform: "translate(177.757 212.197)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27102",
    "data-name": "Group 27102"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27101",
    "data-name": "Group 27101",
    opacity: 0.258,
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52834",
    "data-name": "Path 52834",
    d: "M112.19,165.071c2.276,17.523,11.545,26.792,11.545,26.792.658,8.94,10.969,9.6,10.969,9.6A60.611,60.611,0,0,1,140,181.689a58.044,58.044,0,0,1-15.247-25.338c-7.267-24.022-2.633-50.128-2.3-51.993-5.923,22.459,2.221,49.941-10.256,60.713",
    transform: "translate(-112.19 -104.358)"
  }))))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_52835",
    "data-name": "Path 52835",
    d: "M247.87,154.17s-38.734-27.08-71.641-16.111-30.165,33.592-19.538,37.706h82.04Z",
    transform: "translate(-144.62 161.999)",
    fill: "#6d392f"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_52836",
    "data-name": "Path 52836",
    d: "M133.25,105.45s8.062,45.247,32.057,45.494c20.951.192,16.1-27.285,14.534-34.278-.219-1.042-.384-1.618-.384-1.618l8.693-33.126L142,57.488l-.932,5.073v.082Z",
    transform: "translate(-40.338 26.181)",
    fill: "#6d392f"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_52837",
    "data-name": "Path 52837",
    d: "M172.6,116.666c-.219-1.042-.384-1.618-.384-1.618l8.693-33.126L134.755,57.488l-.932,5.073v.082c-6.06,54.022,37.925,54.022,38.775,54.022",
    transform: "translate(-33.096 26.181)",
    fill: "#452a2b",
    opacity: 0.702
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3494",
    "data-name": "Rectangle 3494",
    width: 140.767,
    height: 7.541,
    transform: "translate(42.693 330.223)",
    fill: "#abdaf7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3495",
    "data-name": "Rectangle 3495",
    width: 43.418,
    height: 7.541,
    transform: "translate(42.693 330.223)",
    fill: "#70b2dd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_52840",
    "data-name": "Path 52840",
    d: "M142.75,159.1s12.45-18.576,31.122-18.277c14.133.225,14.657,9.137,14.657,9.137s9.283-1.108,9.524,9.14Z",
    transform: "translate(-76.293 171.355)",
    fill: "#6d392f"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_52841",
    "data-name": "Path 52841",
    d: "M133.56,162.753s.686-10.283-3.886-11.655-8,2.515-8,2.515-3.428-15.082-16.226-15.54-35.877,12.568-21.71,24.68Z",
    transform: "translate(173.174 175.111)",
    fill: "#6d392f"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_52842",
    "data-name": "Path 52842",
    d: "M79.92,151.291a4.225,4.225,0,0,0,4.223,4.223h77a4.223,4.223,0,1,0,0-8.446h-77a4.225,4.225,0,0,0-4.223,4.223",
    transform: "translate(128.687 182.25)",
    fill: "#70b2dd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_52843",
    "data-name": "Path 52843",
    d: "M79.92,151.291a4.225,4.225,0,0,0,4.223,4.223H138.3a4.223,4.223,0,1,0,0-8.446H84.143a4.225,4.225,0,0,0-4.223,4.223",
    transform: "translate(151.53 182.25)",
    fill: "#abdaf7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_52845",
    "data-name": "Path 52845",
    d: "M53.431,113.476c-1.486,9,1.75,17.027,7.229,17.931s11.125-5.654,12.612-14.655-1.75-17.024-7.229-17.929-11.125,5.654-12.612,14.652",
    transform: "translate(294.05 98.052)",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_52846",
    "data-name": "Path 52846",
    d: "M53.431,113.476c-1.486,9,1.75,17.027,7.229,17.931s11.125-5.654,12.612-14.655-1.75-17.024-7.229-17.929S54.918,104.479,53.431,113.476Z",
    transform: "translate(294.05 98.052)",
    fill: "none",
    stroke: "#f230db",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_52847",
    "data-name": "Path 52847",
    d: "M35.111,229.217H181.3a15.689,15.689,0,0,0,14.534-9.9c17.112-42.724,29.753-84.269,34.881-123.839a15.651,15.651,0,0,0-15.521-17.66H67A15.611,15.611,0,0,0,51.564,91.145C46,127.809,35.111,167.105,20.358,208.376a15.631,15.631,0,0,0,14.753,20.841",
    transform: "translate(229.054 61.6)",
    fill: "#90c6e0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_52848",
    "data-name": "Path 52848",
    d: "M35.093,229.217H175.359a15.689,15.689,0,0,0,14.534-9.9C207,176.593,219.646,135.049,224.774,95.478a15.651,15.651,0,0,0-15.521-17.66H67.013A15.66,15.66,0,0,0,51.547,91.145c-5.539,36.664-16.426,75.96-31.179,117.231a15.615,15.615,0,0,0,14.726,20.841",
    transform: "translate(234.995 61.6)",
    fill: "#abdaf7"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_52849",
    "data-name": "Path 52849",
    d: "M52.833,195.673h56.161a19.137,19.137,0,0,0,18.071-12.889l16.81-58.739c-9.3.027-18.428-.027-27.395-.027-2.989,0-5.978,0-8.94.027L94.159,169.731a15.15,15.15,0,0,1-11.846,9.735l-21.006,3.291a8.685,8.685,0,0,0-7.13,6.718Z",
    transform: "translate(224.459 142.092)",
    fill: "#90c6e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27110",
    "data-name": "Group 27110",
    transform: "translate(306.77 266.11)",
    opacity: 0.35,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_27109",
    "data-name": "Group 27109"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27108",
    "data-name": "Group 27108",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52850",
    "data-name": "Path 52850",
    d: "M62.823,179.466l4.744-.439a17.827,17.827,0,0,0,15-11.079l14.424-43.931c-2.989,0-5.978,0-8.94.027L74.669,169.731a15.15,15.15,0,0,1-11.846,9.735",
    transform: "translate(-62.822 -124.018)",
    fill: "#90c6e0"
  }))))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_52851",
    "data-name": "Path 52851",
    d: "M53.384,113.442c-2.081,8.685.584,16.772,5.953,18.058s11.408-4.711,13.492-13.4-.584-16.772-5.953-18.058-11.41,4.711-13.492,13.4",
    transform: "translate(295.228 100.024)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_52885",
    "data-name": "Path 52885",
    d: "M183.461,249.6a43.754,43.754,0,0,1-2.474,12.8c-5.217,14.582-18.6,21.725-33.947,18.1s21.908,4.713,29-18.1",
    transform: "matrix(0.985, -0.174, 0.174, 0.985, -37.885, 31.483)",
    opacity: 0.164,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27115",
    "data-name": "Group 27115",
    transform: "translate(6081.875 -6093.543)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27113",
    "data-name": "Group 27113",
    transform: "translate(-2083.964 6428.43)",
    opacity: 0.35,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_27112",
    "data-name": "Group 27112"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27111",
    "data-name": "Group 27111",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52855",
    "data-name": "Path 52855",
    d: "M313.437,79.026a64.192,64.192,0,1,1-64.193-64.193,64.193,64.193,0,0,1,64.193,64.193",
    transform: "translate(-185.053 -14.833)",
    fill: "#70b2dd"
  }))))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_52856",
    "data-name": "Path 52856",
    d: "M306.859,74.907a60.4,60.4,0,1,1-60.4-60.4,60.4,60.4,0,0,1,60.4,60.4",
    transform: "translate(-2267.296 6413.036)",
    fill: "#70b2dd"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_52857",
    "data-name": "Path 52857",
    d: "M280.8,64.812a44.439,44.439,0,1,1-44.44-44.44,44.44,44.44,0,0,1,44.44,44.44",
    transform: "translate(-2257.197 6423.131)",
    fill: "#abdaf7"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_52858",
    "data-name": "Path 52858",
    d: "M236.639,57.346H214.747V27.764a4.226,4.226,0,1,0-8.452,0V65.107h30.344a3.88,3.88,0,0,0,0-7.761",
    transform: "translate(-2232.455 6428.581)",
    fill: "#70b2dd"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_27114",
    "data-name": "Group 27114",
    transform: "translate(6201.826 -5946.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52852",
    "data-name": "Path 52852",
    d: "M234.782,154.689l-6.349-39.458-20.183,2.5,7.483,39.226Z",
    transform: "translate(-2229.09 6586.404)",
    fill: "#70b2dd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52853",
    "data-name": "Path 52853",
    d: "M217.785,160.69l6.988-48.7a2.744,2.744,0,1,1,5.429.808l-7.75,50.386H225.4l10.392-38.6a2.816,2.816,0,0,1,5.442,1.445l-9.712,37.158-9.75,4.534Z",
    transform: "translate(-2212.678 6576.775)",
    fill: "#4e8fb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52854",
    "data-name": "Path 52854",
    d: "M253.876,128.4v50.234a8.054,8.054,0,0,1-8.055,8.055H216.8a8.054,8.054,0,0,1-8.055-8.055V128.4Z",
    transform: "translate(-2228.229 6609.067)",
    fill: "#abdaf7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3499",
    "data-name": "Rectangle 3499",
    width: 45.126,
    height: 11.783,
    transform: "translate(-2019.479 6737.465)",
    fill: "#90c6e0"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_27133",
    "data-name": "Group 27133",
    transform: "matrix(-0.999, -0.035, 0.035, -0.999, 3817.379, 599.878)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26071",
    "data-name": "Group 26071",
    transform: "translate(33.046 4.365)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26070",
    "data-name": "Group 26070",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26069",
    "data-name": "Group 26069"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26068",
    "data-name": "Group 26068"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26067",
    "data-name": "Group 26067"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26066",
    "data-name": "Group 26066"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26065",
    "data-name": "Group 26065"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26064",
    "data-name": "Group 26064"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52128",
    "data-name": "Path 52128",
    d: "M.116,4.424c.442-2.679,2.02-4.65,3.525-4.4s2.365,2.619,1.923,5.3-2.022,4.65-3.525,4.4S-.326,7.1.116,4.424Z",
    fill: "#341a1b"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26079",
    "data-name": "Group 26079",
    transform: "translate(6.438 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26078",
    "data-name": "Group 26078",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26077",
    "data-name": "Group 26077"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26076",
    "data-name": "Group 26076"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26075",
    "data-name": "Group 26075"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26074",
    "data-name": "Group 26074"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26073",
    "data-name": "Group 26073"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26072",
    "data-name": "Group 26072"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52129",
    "data-name": "Path 52129",
    d: "M.116,4.424C.558,1.744,2.138-.226,3.641.021s2.365,2.619,1.923,5.3-2.02,4.65-3.525,4.4S-.326,7.1.116,4.424Z",
    fill: "#341a1b"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26087",
    "data-name": "Group 26087",
    transform: "translate(30.935 20.079)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26086",
    "data-name": "Group 26086",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26085",
    "data-name": "Group 26085"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26084",
    "data-name": "Group 26084"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26083",
    "data-name": "Group 26083"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26082",
    "data-name": "Group 26082"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26081",
    "data-name": "Group 26081"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26080",
    "data-name": "Group 26080"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52130",
    "data-name": "Path 52130",
    d: "M15.594,3.532C14.51,6.258,11.27,11.184,2.125,10.1A2.412,2.412,0,0,1,.014,7.957h0A2.4,2.4,0,0,1,2.356,5.3,10.8,10.8,0,0,0,11.189.944,2.408,2.408,0,0,1,14.7.6l.245.213A2.409,2.409,0,0,1,15.594,3.532Z",
    fill: "#341a1b"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26095",
    "data-name": "Group 26095",
    transform: "translate(0 13.306)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26094",
    "data-name": "Group 26094"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26093",
    "data-name": "Group 26093"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26092",
    "data-name": "Group 26092"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26091",
    "data-name": "Group 26091"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26090",
    "data-name": "Group 26090"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26089",
    "data-name": "Group 26089"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26088",
    "data-name": "Group 26088"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52131",
    "data-name": "Path 52131",
    d: "M0,2.672C.153,5.6,1.641,11.3,10.653,13.195a2.417,2.417,0,0,0,2.686-1.353h0a2.394,2.394,0,0,0-1.364-3.265,10.772,10.772,0,0,1-6.966-6.95A2.406,2.406,0,0,0,1.792.186l-.3.123A2.416,2.416,0,0,0,0,2.672Z",
    fill: "#341a1b"
  }))))))))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_27134",
    "data-name": "Group 27134",
    transform: "matrix(-0.999, -0.035, 0.035, -0.999, 3800.27, 614.643)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26143",
    "data-name": "Group 26143",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26142",
    "data-name": "Group 26142"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26141",
    "data-name": "Group 26141"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26140",
    "data-name": "Group 26140"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26139",
    "data-name": "Group 26139"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26138",
    "data-name": "Group 26138"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26137",
    "data-name": "Group 26137"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52137",
    "data-name": "Path 52137",
    d: "M9.84.176C3.283-.9.318,3.3.2,3.479a1.112,1.112,0,0,0-.148.949c2.971,9.966,5.96,20.2,5.989,20.3a1.121,1.121,0,0,0,2.154-.624c-.029-.1-2.908-9.955-5.823-19.743C3.15,3.54,5.4,1.713,9.477,2.382A1.118,1.118,0,1,0,9.84.176Z",
    fill: "#341a1b"
  })))))))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_27135",
    "data-name": "Group 27135",
    transform: "translate(3834.176 677.289) rotate(-175)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25797",
    "data-name": "Group 25797",
    transform: "translate(20.441 27.393)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34542",
    "data-name": "Path 34542",
    d: "M32.959,90.9c11.321-4.136,23.865-3.1,35.747-3.815,6.049-.358,12.228-.907,18.414-1.39a48.531,48.531,0,0,0,2.372-7.352C93.644,60.46,88.51,41.4,79.1,25.633,66.151,9.012,55.709,1.444,37.789,0-1.627.861.773,42.841.049,69.772S6.8,92.8,6.8,92.8,23.544,89.6,32.959,90.9Z",
    transform: "translate(0 0)",
    fill: "#6d392f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27308",
    "data-name": "Group 27308",
    transform: "translate(7.112 43.657) rotate(2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26071-2",
    "data-name": "Group 26071",
    transform: "translate(29.727 5.684)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26070-2",
    "data-name": "Group 26070",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26069-2",
    "data-name": "Group 26069"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26068-2",
    "data-name": "Group 26068"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26067-2",
    "data-name": "Group 26067"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26066-2",
    "data-name": "Group 26066"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26065-2",
    "data-name": "Group 26065"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26064-2",
    "data-name": "Group 26064"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52128-2",
    "data-name": "Path 52128",
    d: "M-.809,5.323C-.839,2.607.372.393,1.9.375S4.682,2.543,4.712,5.258,3.528,10.189,2,10.207-.779,8.038-.809,5.323Z",
    fill: "#341a1b"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26079-2",
    "data-name": "Group 26079",
    transform: "translate(2.765 6.006)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26078-2",
    "data-name": "Group 26078",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26077-2",
    "data-name": "Group 26077"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26076-2",
    "data-name": "Group 26076"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26075-2",
    "data-name": "Group 26075"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26074-2",
    "data-name": "Group 26074"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26073-2",
    "data-name": "Group 26073"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26072-2",
    "data-name": "Group 26072"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52129-2",
    "data-name": "Path 52129",
    d: "M-.81,5.323C-.839,2.607.374.393,1.9.375S4.682,2.543,4.712,5.259,3.53,10.188,2,10.207-.78,8.038-.81,5.323Z",
    fill: "#341a1b"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26087-2",
    "data-name": "Group 26087",
    transform: "translate(30.465 19.774)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26086-2",
    "data-name": "Group 26086",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26085-2",
    "data-name": "Group 26085"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26084-2",
    "data-name": "Group 26084"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26083-2",
    "data-name": "Group 26083"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26082-2",
    "data-name": "Group 26082"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26081-2",
    "data-name": "Group 26081"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26080-2",
    "data-name": "Group 26080"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52130-2",
    "data-name": "Path 52130",
    d: "M14.19,3.508C13.6,6.381,11.261,11.8,2.066,12.313A2.412,2.412,0,0,1-.385,10.572h0A2.4,2.4,0,0,1,1.461,7.548,10.8,10.8,0,0,0,9.4,1.725,2.408,2.408,0,0,1,12.8.78l.278.167A2.409,2.409,0,0,1,14.19,3.508Z",
    fill: "#341a1b"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26095-2",
    "data-name": "Group 26095",
    transform: "translate(-0.656 18.859)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26094-2",
    "data-name": "Group 26094",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26093-2",
    "data-name": "Group 26093"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26092-2",
    "data-name": "Group 26092"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26091-2",
    "data-name": "Group 26091"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26090-2",
    "data-name": "Group 26090"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26089-2",
    "data-name": "Group 26089"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26088-2",
    "data-name": "Group 26088"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52131-2",
    "data-name": "Path 52131",
    d: "M-1.833,4.986C-1.177,7.844,1.279,13.2,10.483,13.5a2.417,2.417,0,0,0,2.411-1.8h0a2.394,2.394,0,0,0-1.911-2.979A10.772,10.772,0,0,1,2.916,3.087,2.406,2.406,0,0,0-.5,2.227L-.776,2.4A2.416,2.416,0,0,0-1.833,4.986Z",
    fill: "#341a1b"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27309",
    "data-name": "Group 27309",
    transform: "translate(20.35 32.35) rotate(2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26143-2",
    "data-name": "Group 26143",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26142-2",
    "data-name": "Group 26142"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26141-2",
    "data-name": "Group 26141"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26140-2",
    "data-name": "Group 26140"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26139-2",
    "data-name": "Group 26139"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26138-2",
    "data-name": "Group 26138"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26137-2",
    "data-name": "Group 26137"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52137-2",
    "data-name": "Path 52137",
    d: "M5.287.337c-6.644.08-8.835,4.73-8.925,4.928a1.112,1.112,0,0,0,.019.96c4.657,9.3,9.377,18.857,9.424,18.954a1.121,1.121,0,0,0,2.013-.988c-.046-.094-4.593-9.3-9.163-18.432.628-.947,2.528-3.137,6.657-3.186A1.118,1.118,0,1,0,5.287.337Z",
    fill: "#341a1b"
  })))))))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_34547",
    "data-name": "Path 34547",
    d: "M.246,0,0,.079",
    transform: "translate(55.538 70.604)",
    fill: "none",
    stroke: "#101830",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34548",
    "data-name": "Path 34548",
    d: "M0,.079.246,0",
    transform: "translate(28.229 71.449)",
    fill: "none",
    stroke: "#101830",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34554",
    "data-name": "Path 34554",
    d: "M7.98,79.894c2.242,2.168,6.39-.017,7.035-3.066s-1.052-6.1-2.979-8.55S7.83,63.493,6.973,60.5a2.229,2.229,0,0,1-.1-1.115c.167-.67.841-1.069,1.448-1.39Q13.411,55.3,18.5,52.61a1.987,1.987,0,0,0,1.048-.944,2.048,2.048,0,0,0-.362-1.573,29.337,29.337,0,0,1-3.411-12.215,3.529,3.529,0,0,1,.653-2.717c1.269-1.306,3.6-.062,4.352,1.6s.715,3.62,1.593,5.217a6.041,6.041,0,0,0,6.723,2.6A8.763,8.763,0,0,0,34.623,39.5a11.289,11.289,0,0,0-9.344-15.772,3.8,3.8,0,0,1-1.848-.429,3.163,3.163,0,0,1-1.019-1.685c-2.317-6.923,7.321-17.4,8.494-24.6,3.657,8.521,3.742,14.438,11.3,19.809A34.808,34.808,0,0,1,56.246,49.1a11.708,11.708,0,0,0-.066,4.968c.782,2.542,3.411,4.023,5.937,4.855s5.263,1.315,7.36,2.954A8.013,8.013,0,0,1,65.893,76.1a7.761,7.761,0,0,0-3.179.79c-2.242,1.531-.849,5.126,1.165,6.948s4.7,3.6,4.685,6.312c-.021,3.52-4.585,5.1-8.071,4.614-2.692-.374-5.812-1.256-7.859.537-2.463,2.155-1.223,6.232-2.359,9.3a6.341,6.341,0,0,1-8.891,3.045,10.457,10.457,0,0,0-1.589-.974c-2.376-.94-4.61,1.477-6.262,3.428-3.907,4.622-10.339,8.213-15.9,5.825-3.4-1.46-5.559-4.747-8.026-7.506S3.57,103.172,0,104.133",
    transform: "translate(64.887 34.091)",
    fill: "#101830"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34559",
    "data-name": "Path 34559",
    d: "M73.121,3.708C72.147.092,65.914-.029,61.916,1.54s-8.342,4-12.427,2.6C46.427,3.1,44.376.042,41.068,0c-3.94-.05-6.053,4.148-9.794,5.192-1.847.516-3.849.2-5.787.071C15.473,4.606,5.309,9.907,1.556,17.741A13.746,13.746,0,0,0,1.855,31,14.311,14.311,0,0,0,15.227,37.22c2.139-.258,4.577-.957,6.274.171,2.58,1.718.408,5.063-.911,7.6-3.857,7.414,3,16.692,12.352,18.61s19.409-2.351,25.08-8.891c2-2.3,3.6-4.9,6.132-6.8s6.445-2.917,9.34-1.431c3.524,1.806,3.653,6.033,5.787,9,3.466,4.826,12.145,5.421,17.824,2.426s8.779-8.5,10.509-13.946a12.9,12.9,0,0,0,.778-5.833c-.761-4.905-6.27-8.849-5.979-13.788.2-3.353,3.054-6.137,5.921-8.471s6.045-4.681,7.218-7.892S114.759.491,110.79.129",
    transform: "translate(0 110.652)",
    fill: "#101830"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34560",
    "data-name": "Path 34560",
    d: "M24.5,62.274C17.222,64.9,9.613,67.741,4.524,73.57S-2,89.2,3.564,94.577c5.03,4.864,13.322,4.123,19.729,1.306,1.706-.753,3.553-1.648,5.355-1.165,3.137.84,3.769,4.872,5,7.88,2.633,6.415,10.168,9.69,17.1,9.469s13.438-3.208,19.725-6.141c4.914-2.288,9.981-4.693,13.522-8.8s5.146-10.4,2.3-15.015c-1.015-1.639-2.58-3.578-1.573-5.226a4.179,4.179,0,0,1,2.047-1.435c6.636-2.854,13.572-5.97,17.882-11.766a32.027,32.027,0,0,0,4.976-11.658c1.452-5.933,2.093-12.265.266-18.1S103.341,22.9,97.312,21.9c-4.4-.732-10.122.191-12.232-3.736a13.217,13.217,0,0,1-.986-3.8c-1.827-9.22-12-15.34-21.331-14.233S45.526,8.338,41.644,16.9",
    transform: "translate(65.463 89.389)",
    fill: "#101830"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34561",
    "data-name": "Path 34561",
    d: "M0,68.873s16.642,6.761,32.764-15.082S45.67,0,45.67,0s22.978,44.43-6.145,65.753S0,68.873,0,68.873Z",
    transform: "translate(75.397 88.157)",
    fill: "#f45642"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_27147",
    "data-name": "Group 27147",
    transform: "translate(3794.57 723.652)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27144",
    "data-name": "Group 27144",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52906",
    "data-name": "Path 52906",
    d: "M22.668,10.211a20.481,20.481,0,0,0-.289-2.552,24.149,24.149,0,0,0-.68-2.837,6.16,6.16,0,0,0-1.274-2.358,5.649,5.649,0,0,0-1.975-1.411A9.856,9.856,0,0,0,16.491.482,18.691,18.691,0,0,0,14.3.147C13.59.085,12.877.028,12.164.011,11.342-.009,10.519,0,9.7.03A19.606,19.606,0,0,0,7.285.282a19.853,19.853,0,0,0-2.14.449A5.792,5.792,0,0,0,2.187,2.539,6.1,6.1,0,0,0,.975,4.856,26.34,26.34,0,0,0,.258,7.938,17.317,17.317,0,0,0,.039,9.952c-.01.215-.026.43-.039.645V11.7c.006.044.014.087.018.131.053.616.087,1.235.164,1.848A19.683,19.683,0,0,0,.7,16.28a13.011,13.011,0,0,0,.57,1.812,5.51,5.51,0,0,0,2.709,2.847,8.748,8.748,0,0,0,2.173.706c.881.178,1.774.273,2.667.365a23.742,23.742,0,0,0,3.166.125c.5-.015,1-.055,1.491-.1.518-.045,1.036-.1,1.552-.165a15.093,15.093,0,0,0,3.017-.646,5.571,5.571,0,0,0,2.673-1.906,6.129,6.129,0,0,0,.9-1.785A19.308,19.308,0,0,0,22.4,14.45c.1-.654.173-1.314.237-1.974a15.506,15.506,0,0,0,.036-2.265",
    transform: "translate(0 -0.001)",
    fill: "#0d1624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52907",
    "data-name": "Path 52907",
    d: "M221.658,22.545h-.226V21.4h-.494v-.2h1.213v.2h-.494Z",
    transform: "translate(-197.82 -18.982)",
    fill: "#0d1624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52908",
    "data-name": "Path 52908",
    d: "M237.285,22.545l-.368-.711c-.043-.121-.078-.226-.107-.328.007.119.012.247.012.347v.692h-.214V21.2h.278l.394.775c.05.138.057.154.095.28.047-.142.066-.195.095-.275l.391-.773h.278v1.338h-.214v-.692c0-.109,0-.223.012-.347-.038.128-.067.218-.116.347l-.358.692Z",
    transform: "translate(-211.85 -18.982)",
    fill: "#0d1624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52909",
    "data-name": "Path 52909",
    d: "M137.017,44.24h2.311a.063.063,0,0,1,.063.064V57.062a.063.063,0,0,1-.063.063h-2.311a.063.063,0,0,1-.064-.063V44.3a.064.064,0,0,1,.064-.064",
    transform: "translate(-122.622 -39.611)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52910",
    "data-name": "Path 52910",
    d: "M54.794,44.24H57.1a.063.063,0,0,1,.063.064V57.062a.063.063,0,0,1-.063.063H54.794a.063.063,0,0,1-.064-.063V44.3a.064.064,0,0,1,.064-.064",
    transform: "translate(-49.003 -39.611)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52911",
    "data-name": "Path 52911",
    d: "M61.371,85.481a8.5,8.5,0,0,0-4.195,1.855,7.593,7.593,0,0,0-2.443,5.984.065.065,0,0,0,.064.065h2.311a.063.063,0,0,0,.063-.063,5.284,5.284,0,0,1,1.6-4.139,5.8,5.8,0,0,1,2.6-1.221Z",
    transform: "translate(-49.006 -76.536)",
    fill: "#fff"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_27313",
    "data-name": "Group 27313",
    transform: "translate(3018.734 38.385)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_142703",
    "data-name": "Path 142703",
    d: "M-67.338.36c7.164,0,12.708-4.572,12.708-12.312,0-7.6-5.544-12.1-12.708-12.1s-12.708,4.5-12.708,12.1C-80.046-4.212-74.5.36-67.338.36Zm0-4.644c-3.744,0-6.588-2.844-6.588-7.632,0-4.716,2.844-7.488,6.588-7.488s6.588,2.772,6.588,7.488C-60.75-7.128-63.594-4.284-67.338-4.284ZM-45.486,0h6.516l7.344-17.784h-5.616L-41.922-5h-.072l-4.572-12.78h-6.372Zm32.472-9.4c0-5.832-3.492-8.676-8.46-8.676-6.012,0-9.684,3.492-9.684,9.36,0,5.652,3.672,9,9.576,9,5.076,0,8.46-2.376,8.568-6.444h-4.824c-.144,1.728-1.512,2.484-3.636,2.484-2.448,0-3.924-1.26-4.176-4.176h12.636Zm-4.824-1.368h-7.668a3.617,3.617,0,0,1,4.032-3.348c2.268,0,3.636,1.044,3.636,3.06ZM-10.6,0H-5.13V-7.668c0-3.96,1.62-5.868,3.96-5.868C.558-13.536,1.6-12.492,1.6-9.9c0,.54-.036,1.44-.108,2.3H6.462c.072-.936.18-2.52.18-3.528,0-4.608-2.124-6.948-5.76-6.948-3.492,0-5.4,1.98-6.156,5.364h-.072l.216-5.076H-10.6ZM17.37,0H36.09V-4.608H23.922c0-.864.252-1.44,3.96-3.132,5.8-2.628,7.7-5.04,7.7-8.82,0-4.248-3.132-7.452-8.928-7.452-6.3,0-9.144,3.564-9.144,8.568a19.43,19.43,0,0,0,.144,2.376H22.77a15.716,15.716,0,0,1-.108-1.98c0-2.88,1.4-4.32,3.816-4.32a3.041,3.041,0,0,1,3.348,3.312c0,2.16-1.26,3.456-5.832,5.616C17.946-7.56,17.37-5.724,17.37,0Zm31.1.324c6.948,0,9.972-4.932,9.972-12.276,0-7.524-3.348-12.06-9.972-12.06-6.588,0-9.9,4.536-9.9,12.06C38.574-4.608,41.6.324,48.474.324Zm0-4.644c-2.88,0-4.176-2.772-4.176-7.6,0-4.86,1.44-7.452,4.176-7.452,2.772,0,4.248,2.592,4.248,7.452C52.722-7.092,51.39-4.32,48.474-4.32ZM70.218.324c6.948,0,9.972-4.932,9.972-12.276,0-7.524-3.348-12.06-9.972-12.06-6.588,0-9.9,4.536-9.9,12.06C60.318-4.608,63.342.324,70.218.324Zm0-4.644c-2.88,0-4.176-2.772-4.176-7.6,0-4.86,1.44-7.452,4.176-7.452,2.772,0,4.248,2.592,4.248,7.452C74.466-7.092,73.134-4.32,70.218-4.32Z",
    transform: "translate(833 293.135)",
    fill: "#f8f9fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142702",
    "data-name": "Path 142702",
    d: "M1.2,0H2.46V-4.62H8.52V0H9.78V-9.87H8.52v4.2H2.46v-4.2H1.2ZM14.475.12c1.845,0,2.775-.735,3.03-1.875h.015c-.015.72-.045,1.41-.06,1.755h1.2V-4.515c0-1.935-1.26-3.015-3.435-3.015-2.01,0-3.27.885-3.27,2.355a3.991,3.991,0,0,0,.03.45h1.11a2.156,2.156,0,0,1-.015-.27c0-1.005.75-1.515,2.115-1.515,1.515,0,2.265.615,2.265,1.89v.54H14.445c-1.98,0-2.715.9-2.715,1.95C11.73-.735,12.795.12,14.475.12Zm.24-1.02c-1.17,0-1.86-.48-1.86-1.23,0-.72.48-1.08,1.695-1.08h2.91v.105C17.46-1.755,16.4-.9,14.715-.9ZM20.76,2.97h1.2V-.015c0-.345-.03-1.125-.045-1.62h.015A2.841,2.841,0,0,0,24.87.12c2.175,0,3.51-1.545,3.51-3.945,0-2.265-1.32-3.7-3.48-3.7a2.758,2.758,0,0,0-2.955,2.025H21.93l.03-1.9h-1.2ZM24.7-.96c-1.68,0-2.745-.9-2.745-2.31v-.45a2.578,2.578,0,0,1,2.715-2.73A2.393,2.393,0,0,1,27.18-3.81C27.18-2.07,26.22-.96,24.7-.96Zm5.55,3.93h1.2V-.015c0-.345-.03-1.125-.045-1.62h.015A2.841,2.841,0,0,0,34.365.12c2.175,0,3.51-1.545,3.51-3.945,0-2.265-1.32-3.7-3.48-3.7A2.758,2.758,0,0,0,31.44-5.505h-.015l.03-1.9h-1.2ZM34.2-.96c-1.68,0-2.745-.9-2.745-2.31v-.45A2.578,2.578,0,0,1,34.17-6.45a2.393,2.393,0,0,1,2.505,2.64C36.675-2.07,35.715-.96,34.2-.96Zm6.225,4.08c1.41,0,1.98-.69,2.865-2.985L46.23-7.41H45.015L42.63-1.215H42.6L39.9-7.41H38.49L41.82,0h.315c-.69,1.68-1.05,2.07-1.86,2.07a3.106,3.106,0,0,1-.915-.15v1A3.063,3.063,0,0,0,40.425,3.12Zm13.9-3c2.055,0,3.375-1.2,3.375-3.06H56.6A1.99,1.99,0,0,1,54.36-.96c-1.44,0-2.37-1.065-2.37-2.745A2.437,2.437,0,0,1,54.435-6.45a1.947,1.947,0,0,1,2.13,2.01h1.11A2.968,2.968,0,0,0,54.42-7.53,3.481,3.481,0,0,0,50.79-3.7C50.79-1.365,52.17.12,54.33.12ZM59.655,0h1.2V-10.4h-1.2Zm3.4-8.355h1.29V-9.87H63.06ZM63.1,0h1.2V-7.41H63.1Zm10.08-4.02c0-2.2-1.245-3.51-3.36-3.51-2.22,0-3.645,1.515-3.645,3.885A3.481,3.481,0,0,0,69.855.12c1.95,0,3.255-1.02,3.33-2.625h-1.11c-.1.975-.96,1.6-2.2,1.6a2.431,2.431,0,0,1-2.49-2.565h5.805Zm-1.11-.315h-4.65a2.323,2.323,0,0,1,2.43-2.175,1.971,1.971,0,0,1,2.22,2.085ZM74.985,0h1.2V-3.645a2.589,2.589,0,0,1,2.79-2.805c1.59,0,2.31.81,2.31,2.07V0h1.2V-4.635A2.779,2.779,0,0,0,79.38-7.53a3.022,3.022,0,0,0-3.21,2.115h-.015l.03-1.995h-1.2ZM87.45.06a3.659,3.659,0,0,0,1.26-.18V-1.14a4.17,4.17,0,0,1-1.155.15c-1.11,0-1.47-.675-1.47-1.8V-6.36H88.77V-7.41H86.085V-9.09h-1.02L85-7.92c-.03.39-.12.51-.36.51h-.99v1.05h1.23v3.645C84.885-1.08,85.65.06,87.45.06Zm5.73.06c2.25,0,3.45-.87,3.45-2.325a1.6,1.6,0,0,0-.735-1.41,5.6,5.6,0,0,0-2.235-.51,9.657,9.657,0,0,1-2.07-.345.791.791,0,0,1-.48-.84c0-.735.825-1.2,2.1-1.2,1.32,0,1.98.51,1.995,1.62h1.11c0-1.665-.93-2.64-3.15-2.64-1.98,0-3.255.9-3.255,2.295a1.714,1.714,0,0,0,.615,1.38,4.947,4.947,0,0,0,2.4.585,8.142,8.142,0,0,1,2.04.345.766.766,0,0,1,.465.765c0,.795-.735,1.26-2.265,1.26S91.02-1.485,91.02-2.475H89.91C89.91-1.05,90.69.12,93.18.12Z",
    transform: "translate(784.5 313.408)",
    fill: "#f8f9fa"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_27251",
    "data-name": "Group 27251",
    transform: "translate(3818.438 270.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27250",
    "data-name": "Group 27250",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52994",
    "data-name": "Path 52994",
    d: "M.715,4.873c5.92,5.232,13.109,9.349,20.947,10.78a33.508,33.508,0,0,0,11.6.133A29.956,29.956,0,0,0,43.34,12.16a26.183,26.183,0,0,0,8.9-8.445,2.5,2.5,0,0,0-.891-3.4,2.538,2.538,0,0,0-3.4.891c-.332.518-.694,1.01-1.055,1.507.523-.719-.078.087-.223.26q-.275.327-.561.644A23.242,23.242,0,0,1,43.5,6.083c-.111.089-.224.175-.334.266.645-.527.167-.13.017-.019q-.344.254-.7.5-.732.5-1.5.954A27.316,27.316,0,0,1,37.753,9.4l.593-.25a29.1,29.1,0,0,1-7.263,1.972l.66-.089a30.022,30.022,0,0,1-7.935-.026l.66.089A36.054,36.054,0,0,1,15.4,8.571l.593.25A42.918,42.918,0,0,1,9.6,5.434Q8.09,4.463,6.656,3.377c-.139-.106-.582-.477.009.01-.106-.088-.218-.17-.326-.256q-.352-.278-.7-.563-.719-.59-1.414-1.207a2.53,2.53,0,0,0-3.512,0,2.517,2.517,0,0,0,0,3.512",
    transform: "translate(0 0)",
    fill: "#f8f9fa"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignerAlt);
export default __webpack_public_path__ + "static/media/Designer-Alt.2e67b680e90fd3f5b3bfd39b55ef30a8.svg";
export { ForwardRef as ReactComponent };